export default __webpack_public_path__ + "61801c974908f6409aec0c52875317ae.svg";